import React from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import Navigation from "@/components/Navigation";
import Footer from "@/components/Footer";
import WhatsAppButton from "@/components/WhatsAppButton";
import ChatbotWidget from "@/components/ChatbotWidget";
import { BUSINESS } from "@/lib/business";

export default function Impressum() {
  return (
    <div data-testid="impressum-page" className="bg-[#050505] text-white min-h-screen">
      <Navigation />
      <main className="max-w-4xl mx-auto px-6 md:px-12 pt-32 pb-24">
        <Link
          to="/"
          data-testid="back-home-link"
          className="inline-flex items-center gap-2 text-zinc-400 hover:text-white text-xs uppercase tracking-[0.2em] font-mono mb-10"
        >
          <ArrowLeft className="w-4 h-4" />
          Zurück
        </Link>

        <h1 className="text-4xl md:text-6xl font-black uppercase tracking-tighter text-white leading-[0.95]">
          Impressum
        </h1>
        <p className="mt-4 text-zinc-500 text-sm font-mono uppercase tracking-[0.2em]">
          Angaben gemäss Handelsregister des Kantons {BUSINESS.canton}
        </p>

        <div className="mt-12 space-y-10 text-zinc-300 leading-relaxed">
          <Section title="Firma">
            <p className="text-white font-bold text-lg">{BUSINESS.legalName}</p>
            <p>Rechtsform: {BUSINESS.legalForm}</p>
            <p>Inhaber: {BUSINESS.ownerFull}</p>
            <p>Eintragung: {BUSINESS.registeredOn}</p>
          </Section>

          <Section title="Adresse">
            <p>{BUSINESS.address}</p>
            <p>{BUSINESS.city}</p>
            <p>{BUSINESS.country}</p>
          </Section>

          <Section title="Kontakt">
            <p>
              Festnetz:{" "}
              <a className="text-white hover:underline" href={`tel:${BUSINESS.phoneOffice.replace(/\s/g, "")}`}>
                {BUSINESS.phoneOffice}
              </a>
            </p>
            <p>
              {BUSINESS.owner} (Mobile):{" "}
              <a className="text-white hover:underline" href={`tel:${BUSINESS.phoneOwner.replace(/\s/g, "")}`}>
                {BUSINESS.phoneOwner}
              </a>
            </p>
            <p>
              {BUSINESS.coOwner} (Mobile):{" "}
              <a className="text-white hover:underline" href={`tel:${BUSINESS.phoneCo.replace(/\s/g, "")}`}>
                {BUSINESS.phoneCo}
              </a>
            </p>
            <p>
              E-Mail:{" "}
              <a className="text-white hover:underline" href={`mailto:${BUSINESS.email}`}>
                {BUSINESS.email}
              </a>
              {" · "}
              <a className="text-white hover:underline" href={`mailto:${BUSINESS.emailOwner}`}>
                {BUSINESS.emailOwner}
              </a>
              {" · "}
              <a className="text-white hover:underline" href={`mailto:${BUSINESS.emailCo}`}>
                {BUSINESS.emailCo}
              </a>
            </p>
          </Section>

          <Section title="Handelsregister / UID">
            <p className="font-mono">UID: {BUSINESS.uid}</p>
            <p>Registereintrag: Handelsregister des Kantons {BUSINESS.canton}</p>
            <p>Eintragungsdatum: {BUSINESS.registeredOn}</p>
          </Section>

          <Section title="Zeichnungsberechtigung">
            <p>{BUSINESS.ownerFull} — Inhaber, Einzelunterschrift</p>
          </Section>

          <Section title="Geschäftstätigkeit / Zweck">
            <ul className="list-disc list-inside space-y-1">
              {BUSINESS.purposes.map((p, i) => (
                <li key={i}>{p}</li>
              ))}
            </ul>
          </Section>

          <Section title="Haftungsausschluss">
            <p>
              Alle Inhalte dieser Website wurden mit grösster Sorgfalt erstellt.
              Für die Richtigkeit, Vollständigkeit und Aktualität der Inhalte
              können wir jedoch keine Gewähr übernehmen. Die Nutzung unserer
              Website erfolgt auf eigene Gefahr.
            </p>
            <p>
              Für Links zu externen Websites sind ausschliesslich deren Betreiber
              verantwortlich.
            </p>
          </Section>

          <Section title="Urheberrecht">
            <p>
              Sämtliche Inhalte, Bilder, Videos und Texte dieser Website sind
              urheberrechtlich geschützt. Eine Verwendung ist nur mit
              ausdrücklicher Zustimmung von {BUSINESS.legalName} zulässig.
            </p>
          </Section>
        </div>
      </main>
      <Footer />
      <WhatsAppButton />
      <ChatbotWidget />
    </div>
  );
}

function Section({ title, children }) {
  return (
    <div className="border-l-2 border-[#e52620] pl-6">
      <h2 className="text-[11px] uppercase tracking-[0.3em] text-zinc-500 font-bold font-mono mb-3">
        {title}
      </h2>
      <div className="space-y-1">{children}</div>
    </div>
  );
}
